import add from './add';
import edit from './edit';
import list from './list';

const module = {
  namespaced: true,
  modules: {
    add,
    edit,
    list,
  },
};

export default module;
